import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type ReconcileCashDrawerParams = {
  financialAccountId: string;
  physicalCount: number;
  notes?: string;
};

export const reconcileCashDrawerAtom = createMutationAtomFactory(
  'finance.reconcileCashDrawer',
  (params: ReconcileCashDrawerParams) => ({
    financeReconcileCashDrawer: {
      __args: {
        input: {
          financialAccountId: params.financialAccountId,
          physicalCount: params.physicalCount,
          ...(params.notes ? { notes: params.notes } : {}),
        },
      },
      adjustment: {
        id: true,
        amount: true,
      },
      discrepancy: true,
      systemBalance: true,
    },
  }),
);
